import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '../../../../pipes/translate/translate.pipe';
import { CellActionType } from '../../../../../features/bizzmine/widgets/collection-list-widget/classes/cell-action-type';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { IconComponent } from '../../../ui/icon/icon.component';
import { TitleFunctionType } from 'src/models/ts/title-function-type.model';
import { DirectEditMode } from 'src/models/ts/direct-edit-mode.model';
import { GridContextPermissions } from 'src/app/features/bizzmine/widgets/collection-list-widget/classes/grid-context-permissions';
import { VersionStateType } from 'src/models/ts/version-state-type.model';
import { CollectionFormField } from 'src/models/ts/collection-form-field.model';
import { ProtectedFieldType } from 'src/models/ts/protected-field-type.model';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

@Component({
  selector: 'bizz-grid-cell-file',
  standalone: true,
  imports: [
    IconComponent
  ],
  templateUrl: './grid-cell-file.component.html',
  styleUrl: './grid-cell-file.component.scss'
})
export class GridCellFileComponent extends GridCellBaseComponent<number> implements OnInit{
  @Input() public downloadEnabled = false;

  public ngOnInit(): void {
    this.apply();
  }

  private apply(): void {
    const isInGrid = this.metaData && this.metaData.formId != null && this.metaData.formId.trim() !== '';
    this.downloadEnabled = (isInGrid && this.hasGridFileValue(this.data)) || !GridContextPermissions.hideDownload(this.data);
  }

  public hasGridFileValue(data: any): boolean {
    const fields = data?.Fields;
    if(fields){
      const collectionFormFields =  <Array<CollectionFormField>>fields;
      const file = collectionFormFields.find(_ => _.ProtectedFieldType == ProtectedFieldType.File);
      return file?.Value != null && file?.Value > 0;
    }
    return false;
  }

  public override onDataChanged(): void {
    this.apply();
    ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

  public downloadFile(): void { //TODO Implement
    this.onCellAction.emit({ 
      action: CellActionType.DOWNLOAD_FILE, 
      data: { data: this.data } 
    });
    //see angjs: ngBizzColumnFile
    //See UploadService R41 -> is now -> DownloadService R42
    //Also requires the VersionCompareService and VersionCompareDownloadModal to be implemented

  }
}
